import packingRequest from "../request/packing"

const apiRequest = packingRequest()

export const getItemsMarkError = (payload) => {
    return apiRequest({
        url: '/order/barcode/list-item-error-histories',
        method: 'POST',
        data: payload
    })
}

export const exportItemsMarkError = (payload) => {
    return apiRequest({
        url: `/order/barcode/export-list-item-error-histories`,
        method: 'POST',
        data: payload,
    })
}

